import { Listing } from 'ha/services/apiV2/types/Listing';
import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

export type CreateListingPayload = Pick<
  Listing,
  'address' | 'currency' | 'kind' | 'price' | 'type' | 'minimumStayMonths'
>;

export default (makeCall: MakeCall) =>
  ({
    address,
    currency,
    kind,
    price,
    type,
    minimumStayMonths,
  }: CreateListingPayload) =>
    makeCall<Listing>('POST', `${APIV2_URL}/listing`, {
      data: {
        address,
        currency,
        kind,
        minimumStayMonths,
        price,
        type,
      },
    });
